var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "basic-img" },
    [
      _c(
        "el-upload",
        {
          attrs: {
            action: "https://jsonplaceholder.typicode.com/posts/",
            "list-type": "picture-card"
          }
        },
        [_c("i", { staticClass: "el-icon-plus" })]
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("p", [_vm._v("商品主图")]),
          _vm._v(" "),
          _c("el-input"),
          _vm._v(" "),
          _c("el-button", { attrs: { type: "primary" } }, [_vm._v("上传")])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76fc944f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76fc944f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/basic/goodsmanage/basic-img.vue
// module id = null
// module chunks = 